import styled from "styled-components";
import { FormControlLabel } from "@mui/material";

export const Container = styled.div`
  position: absolute;
  top: 60px;
  right: 0;
  min-width: 300px;
  max-width: 300px;
  background: #fff;
  height: calc(100vh - 116px);
  padding: 28px 24px;

  video {
    height: 172px;
    width: 100%;
  }
`;

export const TopContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const Title = styled.strong`
  font-family: "Inter", "Courier New", Courier, monospace;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #000;
`;

export const Button = styled.button`
  width: 14px;
  height: 14px;
  background: none;
  border: none;
  cursor: pointer;
`;

export const ExternalBadgeContainer = styled.div`
  display: flex;
  margin-bottom: 8px;
`;

export const ProcessingVideoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 160px;
  width: 100%;
  background: #fff;
  border: 2px solid #000;
  margin-bottom: 24px;

  strong {
    font-size: 14px;
    font-family: "Inter";
    font-weight: 700;
    color: #000;
  }
`;

export const ShareDrawerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ShareDrawerScroll = styled.div`
  height: 100%;
  overflow-y: auto;
  padding-right: 6px;
`;

export const ShareSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const HelperText = styled.span`
  font-size: 12px;
  color: #666;
`;

export const EmailInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const EmailChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const AttachmentControlLabel = styled(FormControlLabel)`
  width: 100%;
  margin: 0;
  align-items: flex-start;

  & + & {
    margin-top: 12px;
  }

  .MuiCheckbox-root {
    flex-shrink: 0;
  }

  .MuiFormControlLabel-label {
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
`;
